export default __webpack_public_path__ + "static/media/akar-icons_twitter-fill.dfc5d106.svg";